import styled from "styled-components";

const padding = "16px 0px";

export const ContainerUploadFile = styled.div`
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
  padding: ${padding};

  .ant-row-flex {
    width: 100% !important;
  }

  .uploadRow,
  .downloadButtonRow {
    margin-top: 10px;
  }

  .ant-row-flex.footer {
    margin-top: 20px !important;
  }

  button:not(:last-child) {
    margin-right: 14px;
  }

  p.message {
    font-family: Asap;
    font-weight: normal;
    font-size: 14px;
    color: #4b4b4b;

    text-align: justify !important;
    margin-bottom: 10px;
  }

  label {
    font-family: Asap;
    color: #4b4b4b;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;

    &.disabled {
      font-weight: bold;
      font-size: 14px;
      margin-left: 0px;
      color: #c4c4c4;
    }
    &.error {
      color: #d44c4c;
    }
    svg {
      margin-left: 5px;
    }
  }

  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    padding-right: 50px !important;
  }

  .ant-input-affix-wrapper .ant-input-prefix,
  .ant-input-affix-wrapper .ant-input-suffix {
    top: 60% !important;
    font-weight: bold !important;
  }

  .ant-upload-drag-icon {
    svg {
      color: #9074bf;
    }
  }

  .ant-upload.ant-upload-drag p.ant-upload-drag-icon {
    position: relative;
    margin-bottom: 10px;
  }

  .ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
    border-color: #c4c4c4c4;
  }

  .ant-upload-list-item-name {
    font-size: 16px !important;
  }

  .anticon-delete {
    font-size: 24px !important;
    padding-right: 32px !important;
    fill: #d44c4c;
  }

  .anticon-picture {
    visibility: hidden !important;
  }
`;
export const ContainerReviewImport = styled.div`
  width: 100%;
  min-width: 100%;
  padding: ${padding};

  .ant-row-flex {
    width: 100% !important;
  }

  .ant-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  p.message {
    font-family: Asap;
    font-weight: normal;
    font-size: 14px;
    color: #4b4b4b;

    text-align: justify !important;
    margin-bottom: 10px;
  }

  label {
    font-family: Asap;
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;

    &.disabled {
      font-weight: bold;
      font-size: 14px;
      color: #c4c4c4;
    }
    &.error {
      color: #d44c4c;
    }
  }
`;
